import moment from 'moment/moment';
import ArrowRight from '@/images/icons/ArrowRight';
import Tooltip from '@/components/Tooltip';
import React from 'react';

const SubscriptionStatus = ({ subscription }) => {
	if (subscription) {
		const stripeStatus = subscription?.stripeSubscription?.status;
		const canceledAt = subscription?.stripeSubscription?.canceled_at;
		const trialEnd = subscription?.stripeSubscription?.trial_end;
		const currentPeriodEnd = subscription?.stripeSubscription?.current_period_end;

		let title, description, content;

		switch (stripeStatus) {
			case 'unpaid':
				content = "Your subscription was canceled automatically due to unpaid invoices.";
				break;
			case 'past_due':
				title = "Next payment";
				content = "Your last payment was unsuccessful. Please update your billing info!";
				break;
			case 'trialing':
				title = subscription?.stripeSubscription?.cancel_at_period_end ? "Will be canceled on" : "Trial is valid until:";
				content = moment(trialEnd * 1000).format("LL");
				break;
			case 'active':
				title = subscription?.stripeSubscription?.cancel_at_period_end ? "Will be canceled on" : "Next payment:";
				content = moment(currentPeriodEnd * 1000).format("LL");
				description = (
					<>
						<div>
							As soon as the transaction fees reach the threshold of $50, you will be charged immediately.
						</div>
						<br />
						<a href="https://help.invitemember.com/"
						   target="_blank"
						   rel="noopener noreferrer"
						   className="hover:underline">
							Read more in Help Center
							<ArrowRight className="inline w-5 h-5 ml-1" />
						</a>
					</>
				);
				break;
		}

		return (
			<div>
				<div className="text-[11px] md:text-[13px]/[1.2] text-[#A5A5A5] font-medium mb-2">{title}</div>
				<div>
					<span className="text-sm md:text-base">{content}</span>
					{description && (
						<Tooltip className="inline-block ml-1 md:ml-1.5 -top-px" size="lg" bg="dark">
							<div className="text-[13px]/[1.4]">
								{description}
							</div>
						</Tooltip>
					)}
				</div>
			</div>
		);
	}

	return null;
};

export default SubscriptionStatus;
